import { useCallback, useMemo, useState } from 'react';

export const AGREEMENT_VALUES = {
  AGREE: 'AGREE',
  DISAGREE: 'DISAGREE',
} as const;

export type AgreementValueType = keyof typeof AGREEMENT_VALUES;

export const useAgreementMap = (originalArray: { id: number }[]) => {
  const [selectedMap, setSelectedMap] = useState<Map<number, AgreementValueType>>(new Map());

  const handleChangeAgreement = useCallback((id: number, agreement: AgreementValueType) => {
    setSelectedMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(id, agreement);

      return newMap;
    });
  }, []);

  const setAllAgreements = useCallback(
    (agreement: AgreementValueType) => {
      setSelectedMap((prevMap) => {
        const newMap = new Map(prevMap);
        originalArray.forEach((item) => {
          newMap.set(item.id, agreement);
        });

        return newMap;
      });
    },
    [originalArray]
  );

  const isAllSelected = originalArray.every((item) => selectedMap.has(item.id));

  const isAllAgreed = useMemo(
    () => originalArray.every((item) => selectedMap.get(item.id) === AGREEMENT_VALUES.AGREE),
    [originalArray, selectedMap]
  );

  return {
    selectedMap,
    handleChangeAgreement,
    isAllSelected,
    setAllAgreements,
    isAllAgreed,
  };
};
